(function () {
    'use strict';

    angular
        .module('vm.common')
        .factory('Auth', Auth);

    function Auth($cookies) {
        return {
            redirectToFrontend
        };

        //////////////

        function redirectToFrontend(token, redirectPath = null) {
            var cookieOptions = {
                path: '/',
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
            };

            try {
                $cookies.remove('preferV4', cookieOptions);
                $cookies.remove('preferMobile', cookieOptions);
            }
            catch (e) {}

            // if (getScreenWidth() < 1000) {
            //     $cookies.put('preferMobile', 'true', cookieOptions);
            //
            //     window.location.href = '/?nc#/auto-login?token=' + token;
            // }
            // else {
                $cookies.put('preferV4', 'true', cookieOptions);

                let url = '/?nc#/auto-login;token=' + token;

                if (redirectPath) {
                    url += ';location=' + encodeURIComponent(redirectPath);
                }

                console.log(url);

                window.location.href = url;
            // }
        }

        function getScreenWidth() {
            try {
                return window.innerWidth
                    || document.documentElement.clientWidth
                    || document.body.clientWidth;
            } catch (err) {
                console.error(err);
                return 0;
            }
        }
    }
}());